export default __webpack_public_path__ + "static/media/responsive.4f6a8949.png";